import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '../lib/api';
import { Reveal } from './Reveal';

export default function ClientLogoWall({ compact = false }) {
    const [clients, setClients] = useState(null);

    useEffect(() => {
        api.get('/clients')
            .then((r) => setClients(r.data))
            .catch(() => setClients([]));
    }, []);

    const shown = compact && clients ? clients.slice(0, 12) : clients;

    return (
        <section className="py-24 sm:py-32 border-t border-line bg-ink2/40">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-bronze flex items-center gap-3">
                            <span className="inline-block w-10 h-px bg-bronze" />
                            Client Portfolio
                        </p>
                        <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream">
                            Trusted by organizations <span className="text-bronze">shaping markets.</span>
                        </h2>
                    </div>
                    <p className="max-w-sm text-sm text-fog leading-relaxed">
                        A decade of counsel across infrastructure, capital, life sciences, energy,
                        defense, and technology. Representative portfolio shown.
                    </p>
                </Reveal>

                <div
                    data-testid="client-logo-wall"
                    className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-line border border-line"
                >
                    {shown === null
                        ? Array.from({ length: 12 }).map((_, i) => (
                              <div key={i} className="bg-ink aspect-[4/3] animate-pulse" />
                          ))
                        : shown.map((c, i) => (
                              <motion.div
                                  key={c.id}
                                  data-testid="client-logo-item"
                                  initial={{ opacity: 0 }}
                                  whileInView={{ opacity: 1 }}
                                  viewport={{ once: true }}
                                  transition={{ duration: 0.7, delay: (i % 6) * 0.06 }}
                                  className="group bg-ink hover:bg-surface aspect-[4/3] flex flex-col items-center justify-center gap-2 transition-colors duration-500 px-4"
                              >
                                  {c.logo_path ? (
                                      <img
                                          src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${c.logo_path}`}
                                          alt={c.name}
                                          className="max-h-12 max-w-[80%] object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                                      />
                                  ) : (
                                      <span className="font-serif text-3xl sm:text-4xl font-semibold text-cream/50 group-hover:text-bronze transition-colors duration-500 tracking-tight">
                                          {c.initials}
                                      </span>
                                  )}
                                  <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-fog/70 group-hover:text-fog transition-colors duration-500">
                                      {c.name}
                                  </span>
                              </motion.div>
                          ))}
                </div>
            </div>
        </section>
    );
}
